export function About() {
  return (
    <section id="about" className="py-24 px-8 lg:px-12 bg-[#F8F7F4]">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid lg:grid-cols-[1fr,1.4fr] gap-20 items-start">
          <div className="bg-[#111820] rounded-xl p-10 text-center">
            <div className="w-[100px] h-[100px] bg-[#2E7D4F]/20 border-2 border-[#2E7D4F]/40 rounded-full flex items-center justify-center mx-auto mb-5">
              <span
                className="text-[32px] font-bold text-[#3B9B63]"
                style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
              >
                BS
              </span>
            </div>
            <div className="text-[18px] font-semibold text-white mb-1">Brandon Sowle</div>
            <div className="text-[12px] font-medium tracking-[0.12em] uppercase text-[#3B9B63] mb-6">
              Founder & Landman
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {["15+ Years", "Oklahoma", "Oil & Gas"].map((tag) => (
                <span
                  key={tag}
                  className="bg-white/[0.06] border border-white/10 text-white/55 text-[11px] font-medium tracking-[0.06em] px-3 py-[5px] rounded-[2px]"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#2E7D4F] mb-4">
              About LandTrack
            </div>
            <h2
              className="text-[26px] font-bold text-[#1A2332] mb-4 leading-[1.25]"
              style={{ fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif" }}
            >
              Born from experience in the field
            </h2>
            <p className="text-[15px] text-[#4A5568] leading-[1.8] font-light mb-5">
              After{" "}
              <strong className="text-[#1A2332] font-semibold">
                15 years as a professional landman
              </strong>{" "}
              working across Oklahoma and 10 other states, I saw the same challenge repeatedly:
              acquisition companies moving too fast to keep accurate records of what they owned.
            </p>
            <p className="text-[15px] text-[#4A5568] leading-[1.8] font-light mb-5">
              Spreadsheets got outdated. Email threads became the source of truth. Critical details
              were lost in the shuffle.{" "}
              <strong className="text-[#1A2332] font-semibold">
                Deals were happening faster than record-keeping could follow.
              </strong>
            </p>
            <p className="text-[15px] text-[#4A5568] leading-[1.8] font-light mb-5">
              LandTrack was built to solve this exact problem. It's the system I wish my clients had
              — purpose-built for acquisition teams who need to stay organized without slowing down.
            </p>
            <div className="mt-8 pt-8 border-t border-[#DDE2E8]"></div>
          </div>
        </div>
      </div>
    </section>
  )
}
